import React from 'react';
import { Users } from 'lucide-react';
import { Guest } from './guestFilters';
import { ConviveCard } from './ConviveCard';

// Une fiche pèse bien plus lourd qu'une ligne de tableau : rendre les 350 convives d'un grand événement
// d'un seul coup rendait le premier affichage et le défilement poussifs. On en affiche 60, le reste à la
// demande — dans la pratique les filtres ramènent presque toujours la liste sous ce seuil. Choix validé
// avec Emeni (2026-08-24) plutôt qu'un défilement infini, plus complexe pour un gain nul ici.
const PAGE_SIZE = 60;

export function ConvivesGrid({ guests, resetKey, sending, onOpen, onSendInvitation, onShowHistory, onDelete }: {
    guests: Guest[];
    /** Signature des filtres courants — remet la pagination à la première page dès qu'ils changent, sinon
     *  on garderait "300 fiches affichées" en basculant sur un filtre qui n'en ramène que 12. */
    resetKey: string;
    sending: boolean;
    onOpen: (g: Guest) => void;
    onSendInvitation: (g: Guest) => void;
    onShowHistory: (g: Guest) => void;
    onDelete: (g: Guest) => void;
}) {
    const [visible, setVisible] = React.useState(PAGE_SIZE);

    React.useEffect(() => { setVisible(PAGE_SIZE); }, [resetKey]);

    if (guests.length === 0) {
        return (
            <div className="py-16 text-center bg-white dark:bg-surface rounded-2xl border border-dashed border-gray-300 dark:border-border">
                <Users size={40} className="text-slate-400 dark:text-gray-700 mx-auto mb-3" />
                <p className="text-sm text-slate-500 dark:text-content-muted font-medium">Aucun convive ne correspond à la recherche ou aux filtres.</p>
            </div>
        );
    }

    const shown = guests.slice(0, visible);
    const remaining = guests.length - shown.length;

    return (
        <div className="space-y-4">
            {/* 4 colonnes sur les tres grands ecrans : sans cette palier, les fiches restaient a 3 et
                s'etiraient betement une fois la page passee en pleine largeur. */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                {shown.map((g) => (
                    <ConviveCard key={g.id} guest={g} sending={sending}
                        onOpen={() => onOpen(g)}
                        onSendInvitation={() => onSendInvitation(g)}
                        onShowHistory={() => onShowHistory(g)}
                        onDelete={() => onDelete(g)} />
                ))}
            </div>
            {remaining > 0 && (
                <div className="flex justify-center">
                    <button type="button" onClick={() => setVisible((v) => v + PAGE_SIZE)}
                        className="px-4 py-2 rounded-xl bg-surface border border-border text-xs font-bold text-content-muted hover:text-content hover:border-brand-500/40 transition-colors">
                        Afficher {Math.min(PAGE_SIZE, remaining)} fiche(s) de plus ({remaining} restante(s))
                    </button>
                </div>
            )}
        </div>
    );
}
